import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface OneLineCardSkeletonProps {
  cardsCount: number;
  baseColor: string;
  highlightColor: string;
}

const OneLineCardSkeleton: React.FC<OneLineCardSkeletonProps> = ({
  cardsCount,
  baseColor,
  highlightColor,
}) => {
  const arr = Array(cardsCount).fill(0);

  return (
    <>
      {arr.map((_, i) => (
        <div className="card-card-skeleton--one-line" key={i}>
          <div>
            <Skeleton baseColor={baseColor} highlightColor={highlightColor} />
          </div>
        </div>
      ))}
    </>
  );
};

export default OneLineCardSkeleton;
